/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * New order request
 */
export interface NewOrderRequest {
  /**
   * Main account or subaccount ID. Main account is used if not set
   */
  accountId?: number;
  /**
   * Pair name.
   */
  pairName: string;
  /**
   * Orders side.
   */
  side: NewOrderRequest.SideEnum;
  /**
   * Default - MARKET.
   */
  ordType?: NewOrderRequest.OrdTypeEnum;
  /**
   * Default value - IOC
   */
  timeInForce?: NewOrderRequest.TimeInForceEnum;
  /**
   * Amount in base or quote asset.
   */
  requestAmount: number;
  /**
   * Indicates if requested amount is in base or quote asset.
   */
  requestInBaseAsset: boolean;
  /**
   * Limit price, required in OrdType = LIMIT.
   */
  limitPrice?: number;
}
export namespace NewOrderRequest {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
  export const OrdTypeEnum = {
    Limit: 'LIMIT',
    Market: 'MARKET',
    StopLimit: 'STOP_LIMIT',
  } as const;
  export type OrdTypeEnum = (typeof OrdTypeEnum)[keyof typeof OrdTypeEnum];
  export const TimeInForceEnum = {
    Ioc: 'IOC',
    Gtc: 'GTC',
  } as const;
  export type TimeInForceEnum = (typeof TimeInForceEnum)[keyof typeof TimeInForceEnum];
}
